module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/eyeCream@2x_df551e.png";